import { Stack } from '@mui/material';
import { HeaderBreadcrumbs, ScreenWrap } from '../../components';
import { useParams } from 'react-router';
import DailyTipForm from './DailyTipForm';

export default function CreateDailyTipScreen() {
  const { weekNumber, weekId } = useParams();

  return (
    <ScreenWrap>
      <Stack gap={3}>
        <HeaderBreadcrumbs
          title="Create Daily Tip"
          items={[
            {
              name: `Program Week ${weekNumber}`,
              url: `/program/${weekNumber}/${weekId}/daily-tips`,
            },
          ]}
        />
        <DailyTipForm existing={undefined} />
      </Stack>
    </ScreenWrap>
  );
}
